import React from "react";
import styles from './topMenu/TopMenu.module.scss'
import Button from "../../../Componnets/Button/Button";

const TopMenu = ({ handleTriggerShowModal, numberOfResults = null }) => {

  return (
    <div className={[styles.TopMenu, 'd-flex align-items-center'].join(' ')}>
      <div className={styles.results}>
        <span>{numberOfResults ? numberOfResults : null} Result(s)</span>
      </div>
      <div className={styles.inputHolder}>
        <input type={'text'} placeholder={'Search'} />
      </div>
      <div className={[styles.buttonsWrapper, 'd-flex ml-auto'].join(' ')}>
        <div className={'mr-3'}>
          <Button onClick={handleTriggerShowModal} type={'outline'} size={'large'} title={'Import BPMN Model'} />
        </div>
        <div>
          <Button type={'primary'} size={'large'} title={'Create BPMN Model'} />
        </div>
      </div>
    </div>
  )
};

export default TopMenu;